import { create } from 'zustand';

export interface MatterBreadcrumb {
  id: string;
  number: string;
  name: string;
  status: string;
}

interface MatterBreadcrumbState {
  breadcrumb: MatterBreadcrumb | null;
  set: (b: MatterBreadcrumb | null) => void;
}

export const useMatterBreadcrumbStore = create<MatterBreadcrumbState>((set) => ({
  breadcrumb: null,
  set: (breadcrumb) => set({ breadcrumb }),
}));
